import { Injectable } from '@angular/core';
import { AngularFireDatabase } from '@angular/fire/database';
import { Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class PagesService {
  baseUrl: string;
  apiKey: string;
  public pageRef: firebase.database.Reference;
  public pageListRef: firebase.database.Reference;
  public materialsRef: firebase.database.Reference;
  constructor(private db: AngularFireDatabase, private platform: Platform) {
    this.baseUrl = localStorage.getItem('baseUrl');
    this.apiKey = localStorage.getItem('APIKey');
    this.pageRef = db.database.ref(`/com_content`);
    this.pageListRef = db.database.ref('/com_content/article');
    this.materialsRef = db.database.ref('/com_shelcaster_training');
  }

  getPages() {
    //if (this.platform.is('ios') || this.platform.is('android')) {
      return this.pageRef.child('article');
    //}
  }

  getPage(alias: string) {
    //if (this.platform.is('ios') || this.platform.is('android')) {
      return this.pageListRef.child(`${alias}`);
    //}
  }

  getCourseMaterials() {
    return this.materialsRef.child('trainingcoursematerial');
  }
}
